export default class CallinTrackingSerializer {
  static serialize(data) {
    const payload = {
      ...data
    };

    return payload;
  }

  static deSerialize(data) {
    return {
      ...data,
    };
  }
}